import React from "react";
import PageWrapper, { PageHero } from "../components/PageWrapper";
import LeadForm from "../components/LeadForm";
import { Mail, MapPin, Phone, MessageCircle } from "lucide-react";

export default function ContactPage() {
  return (
    <PageWrapper testId="contact-page">
      <PageHero
        eyebrow="Contact"
        title="Talk to our institutional team."
        description="Headquartered in the UAE. Engaged across the world. Reach out — and our partnerships team will respond shortly."
      />

      <section className="bg-white py-24 sm:py-28">
        <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 space-y-8">
            <div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-gold-500">
                Address
              </div>
              <div className="mt-3 flex items-start gap-3">
                <MapPin className="text-navy mt-1" size={18} />
                <div data-testid="contact-address" className="text-navy text-base leading-relaxed">
                  Destineze Educational Voyages FZCO
                  <br />
                  IFZA Business Park, Dubai Silicon Oasis,
                  <br />
                  Dubai, United Arab Emirates
                </div>
              </div>
            </div>

            <div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-gold-500">
                Email
              </div>
              <a
                href="mailto:info@destineze.com"
                data-testid="contact-email"
                className="mt-3 flex items-center gap-3 text-navy hover:text-gold-500 transition"
              >
                <Mail size={18} /> info@destineze.com
              </a>
            </div>

            <div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-gold-500">
                WhatsApp / Phone
              </div>
              <a
                href="https://wa.me/971504883656"
                data-testid="contact-whatsapp"
                className="mt-3 flex items-center gap-3 text-navy hover:text-gold-500 transition"
              >
                <Phone size={18} /> +971 50 488 3656
              </a>
              <a
                href="https://wa.me/971504883656?text=Hello%20Destineze%2C%20I%20would%20like%20to%20discuss%20a%20partnership."
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-cta"
                className="mt-5 inline-flex items-center gap-2 px-5 py-3 bg-[#25D366] text-white text-xs uppercase tracking-[0.18em] font-semibold hover:opacity-90 transition"
              >
                <MessageCircle size={16} /> Chat on WhatsApp
              </a>
            </div>

            <div className="aspect-[16/10] bg-slate-100 border border-slate-200 overflow-hidden">
              <iframe
                title="Destineze Dubai Office"
                data-testid="contact-map"
                src="https://www.google.com/maps?q=Dubai+Silicon+Oasis,+Dubai,+UAE&output=embed"
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <LeadForm
              inquiryType="general"
              testIdPrefix="contact-lead-form"
              title="Send us a message"
              subtitle="Tell us about your context. Our team will respond within one business day."
            />
          </div>
        </div>
      </section>
    </PageWrapper>
  );
}
